export default __webpack_public_path__ + "static/media/img-13.47a8f079.jpg";